import {useFilterByLicense} from '@/biz/license.jsx'
import {useMapContext} from '@/components/MindMap/index.mjs'
import MenuButton from '../MenuButton.jsx'

export default function MenuButtonAiGenerateReqDoc(props) {
    const filterByLicense = useFilterByLicense()
    const map = useMapContext()
    const onClick = () => map.commands.aiGenerateReqDoc()

    return filterByLicense('M00040001',
        <MenuButton
            onClick={onClick}
            {...props}
        >
            AI生成软需文档
        </MenuButton>
    )
}
